import React, { useCallback } from 'react';
// import logo from '../../assets/logo-light.png';
import './Footer.css';

export default function Footer() {
  const user = sessionStorage.getItem('@auth/userName');
  const data = useCallback(() => {
    const dayList = [
      'domingo',
      'segunda-feira',
      'terça-feira',
      'quarta-feira',
      'quinta-feira',
      'sexta-feira',
    ];
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date();
    const dateFull = date.toLocaleDateString('pt-br', options);
    const dayWeek = date.getDay();
    const day = dayList[dayWeek];
    return `${day}, ${dateFull}`;
  }, []);

  const usuarioDev = sessionStorage.getItem('@auth/usuarioDev') === 'true';
  const usuarioSup = sessionStorage.getItem('@auth/usuarioSup') === 'true';

  return (
    <div className="footerContainer">
      <div />

      <div className="footerItem">
        Usuário de{' '}
        <b> {usuarioDev && !usuarioSup ? 'Desenvolvimento' : 'Suporte'} </b>
        logado -<b> {user}</b>
      </div>

      <div className="footerText text-muted" title={data()}>
        {data()}
      </div>
    </div>
  );
}
